import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Store, { useAppDispatch, useAppSelector } from '../../store';
import { trocarSenha, clearError } from '../../store/slices/authSlice';
// import Store from '../../store';
import { LoginForm, S } from '../../components/Login';

const LoginContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, error, resetPasswordSuccess } = useAppSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (resetPasswordSuccess) {
      alert(
        'Solicitação de redefinição de senha enviada com sucesso. Verifique seu e-mail para instruções.'
      );
    }
  }, [resetPasswordSuccess]);

  const handleSubmit = async (
    email: string,
    password: string,
    empresa: string
  ) => {
    Store.load.show(dispatch, 'Autenticando');
    await Store.auth.login(dispatch, email, password, empresa);
    Store.load.hide(dispatch);
  };

  const handleForgotPassword = (email: string, empresa: string) => {
    if (!email || !empresa) {
      Store.dialog.alert(
        dispatch,
        'Por favor, preencha os campos de e-mail e empresa para redefinir sua senha.'
      );
      return;
    }

    try {
      dispatch(trocarSenha({ email, empresa }));
    } catch (error) {
      console.error('Erro ao trocar senha:', error);
    }
  };

  return (
    <S.LoginContainer>
      <S.LoginContent>
        <S.LogoContainer>
          <S.LogoImage
            src="/logos/adasistemas_logo.webp"
            alt="ADA Sistemas Logo"
          />
        </S.LogoContainer>
        <S.FormSide>
          <LoginForm
            onSubmit={handleSubmit}
            onForgotPassword={handleForgotPassword}
            error={error}
            onClearError={() => dispatch(clearError())}
          />
        </S.FormSide>
      </S.LoginContent>
      <S.Footer>
        © 2002 - {new Date().getFullYear()} por ADA Sistemas - ME. Todos os
        direitos reservados.
      </S.Footer>
    </S.LoginContainer>
  );
};

export default LoginContainer;
